import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";
import { Bar } from "components/charting/HorizontalBar";

interface BarChartTooltipProps {
  bar: Bar;
  index: number;
  color: string | null;
  labels?: string[];
  xAxisLabel?: string;
}

export default function BarChartTooltip(props: BarChartTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const { bar, index, color, labels, xAxisLabel }: BarChartTooltipProps = props;

  return (
    <Box>
      {/* Title */}
      <Typography sx={{mb: 1}} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            backgroundColor: color,
            display:"inline-block",
            mr: 1,
            borderRadius: "3px"
          }} />
        {bar.label === "subAgg" ? <TitleCase text={bar.field_label || ""}/> : <TitleCase text={bar.label}/>}
      </Typography>

      {/* Label */}
      {labels && xAxisLabel &&
        <Typography>
          <TitleCase text={xAxisLabel} />: 
          <Box sx={{display:"inline-block", ml: 1, fontWeight: "bold" }}>
            <TitleCase text={labels[index]}/>
          </Box>
        </Typography>
      }

      {/* Count */}
      <Typography>
        {bar.category_label ? <TitleCase text={bar.category_label} /> : i18n.t("records")}:
        <Box sx={{display:"inline-block", ml: 1}}>
          <ISONumber number={bar.values ? bar.values[index] : bar.count} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      {/* Percentage */}
      {bar.percent && 
        <Typography>
          {i18n.t("percent")}:
          <Box sx={{display:"inline-block", ml: 1}}>
            <ISOPercentage value={bar.percent} sx={{ fontWeight: "bold" }}/>
          </Box>
        </Typography>
      }
    </Box>
  );
}
